import { Injectable } from '@angular/core';
//import { AuthHttp } from 'angular2-jwt';

import { Observable } from 'rxjs';

@Injectable()
export class ListNotesService {
  public activeFilters: any = {};
  public valFiltres = {};
  public validFilters;

  public getSearchValues(id) { return (this.valFiltres[id]?this.valFiltres[id]:""); }

  constructor() { }
}
